import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { PhotoModel } from '@models/common/PhotoModel';
import { Api } from '@api';

export class IntroVideoCourse extends Model({
  id: types.identifierNumber,
  source: types.string,
  covers: types.array(PhotoModel),
}) {
  get streamSource() {
    return Api.Hub.getTutorialStreamSourceUrl({ id: this.id });
  }
}

export const IntroVideoCourseModel = model(IntroVideoCourse);
